<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span style="color: #ff0202">{{ "notify_token_exprired.title" | translate }}</span>
</h2>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="row mt-2" style="padding: 5px 10px">
    <div class="pl-0" style="font-size: medium; overflow-wrap: break-word">
      {{ "notify_token_exprired.before" | translate }}
      <br/> {{"notify_token_exprired.after" | translate}}
    </div>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
  <!--build icon, set default cancel-->
  <button mat-raised-button color="primary" class="ml-2" (click)="reLogin()">
    {{ "button.reLogin" | translate }}
  </button>
</div>
